export default __webpack_public_path__ + "static/prepare-boy-72b1289278cd1db1f9838597abe50f09.gif";